import { request, success, failure } from './requestStatus'

export const Request = query => `${query}_${request}`
export const Success = query => `${query}_${success}`
export const Failure = query => `${query}_${failure}`
